import queryString from 'query-string';
import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getPromoReferralInfoApi, getShortLinkApi } from 'api/client';
import useClientErrorHandler from 'client/hooks/useClientErrorHandler';
import useShareLink from 'hooks/useShareLink';

const useGetReferralData = ({
    promoUUID,
    promoId,
    missionPromoUUID,
    latestEntryId,
    latestEntryUuid,
    dependency = []
}) => {
    const { test_code, test_expired } = queryString.parse(window.location.search);
    const { isMgmSelf, isMgmShare } = useSelector(s => s.flags);
    const { isLogin } = useSelector(s => s.userLoginState);
    const { currentEntryUUID, currentEntryId } = useSelector(s => s.userEntryState);
    const [isLoading, setIsisLoading] = useState(false);
    const [referralCode, setReferralCode] = useState('');
    const [referralUrl, setReferralUrl] = useState('');
    const [referralCount, setReferralCount] = useState(0);
    const dependencyGuard = [isLogin, currentEntryUUID, ...dependency].every(Boolean);
    const isMgmPromo = isMgmSelf || isMgmShare;
    const errHandler = useClientErrorHandler();
    const getShareUrl = useShareLink({ domain: window.location.host });

    const getReferralData = useCallback(
        async isMgmPromo => {
            try {
                setIsisLoading(true);
                const [shortLinkResp, referralInfoResp] = await Promise.all([
                    // 邀請模組會透過 short link api 取得短網址 (任務模組)
                    // 一般分享會透過 short link api 取得短網址 (當下的模組)
                    getShortLinkApi(isMgmShare ? missionPromoUUID : promoUUID),
                    isMgmPromo ? getPromoReferralInfoApi(promoUUID) : Promise.resolve(true)
                ]);
                if (shortLinkResp.httpStatus === 200) {
                    const {
                        payload: { shortLink }
                    } = shortLinkResp;
                    setReferralUrl(shortLink);
                }

                if (referralInfoResp.httpStatus === 200) {
                    const {
                        payload: { referralCode, counts }
                    } = referralInfoResp;
                    setReferralCode(referralCode);
                    setReferralCount(counts);
                }
            } catch (err) {
                errHandler({ err });
            } finally {
                setIsisLoading(false);
            }
        },
        [errHandler, isMgmShare, missionPromoUUID, promoUUID]
    );

    useEffect(() => {
        if (Boolean(promoUUID) && dependencyGuard) {
            getReferralData(isMgmPromo);
        }
    }, [getReferralData, promoUUID, dependencyGuard, isMgmPromo]);
    const referralLink =
        Boolean(referralUrl) && Boolean(referralCode) && `${referralUrl}/r/${referralCode}`;
    const shareLink =
        Boolean(referralUrl) && Boolean(currentEntryId) && `${referralUrl}/r/${currentEntryId}`;

    return {
        getReferralData,
        referralCode,
        // [860t0x3m9] 若段網址沒有產生，則用現有資料組成分享長網址
        referralUrl:
            referralLink ||
            shareLink ||
            getShareUrl({
                testCode: { test_code, test_expired },
                promoId,
                promoUUID,
                entryId: latestEntryId,
                entryUUID: latestEntryUuid,
                referralCode
            }),
        referralCount,
        isLoading
    };
};

export default useGetReferralData;
